import type { ComponentProps } from 'react';
import { Toaster as SonnerToaster } from 'sonner';

export const Toaster = (props: ComponentProps<typeof SonnerToaster>) => (
  <SonnerToaster
    position='top-right'
    expand
    visibleToasts={8}
    closeButton
    toastOptions={{ unstyled: true, style: { width: '100%' } }}
    {...props}
  />
);
